import type { ObjectiveType } from "./objectiveTypes.service";

/**
 * The pair to swap when moving ``id`` one step up (-1) or down (1) in the
 * ordered list, or null at either end. Keyed by id, not by row index:
 * PanelList hands renderItem a page-relative index (TD-004).
 */
export function swapPair(
  items: ObjectiveType[],
  id: string,
  direction: -1 | 1,
): [ObjectiveType, ObjectiveType] | null {
  const index = items.findIndex((item) => item.id === id);
  const neighbor = index + direction;
  if (index < 0 || neighbor < 0 || neighbor >= items.length) return null;
  return [items[index], items[neighbor]];
}
